export const companyData = {
  name: "Zany Automation",
  tagline: "Revolutionizing Business Through Intelligent Automation",
  description: "Transform your business operations with our cutting-edge automation solutions. We specialize in both technical and business process automation to help you scale efficiently.",
};

export const heroData = {
  title: "Automate Everything, Scale Infinitely",
  subtitle: "Transform your business with intelligent automation solutions that save time, reduce costs, and boost productivity by up to 400%",
  ctaPrimary: "Start Your Automation Journey",
  ctaSecondary: "View Case Studies",
  stats: [
    { number: "500+", label: "Processes Automated" },
    { number: "98%", label: "Client Satisfaction" },
    { number: "2.4M", label: "Hours Saved" }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Business Process Automation",
    description: "Streamline workflows, automate repetitive tasks, and optimize business operations with intelligent process automation.",
    features: ["Workflow Automation", "Document Processing", "Data Integration", "Task Management"],
    icon: "Workflow"
  },
  {
    id: 2,
    title: "DevOps & Infrastructure Automation",
    description: "Scale your technical operations with automated deployment, monitoring, and infrastructure management solutions.",
    features: ["CI/CD Pipelines", "Infrastructure as Code", "Monitoring & Alerts", "Auto-scaling"],
    icon: "Server"
  },
  {
    id: 3,
    title: "Cloud Automation Solutions",
    description: "Leverage cloud technologies with automated provisioning, management, and optimization across all major platforms.",
    features: ["Multi-cloud Management", "Resource Optimization", "Security Automation", "Cost Management"],
    icon: "Cloud"
  },
  {
    id: 4,
    title: "Data & Analytics Automation",
    description: "Transform raw data into actionable insights with automated data pipelines, reporting, and analytics solutions.",
    features: ["Data Pipelines", "Automated Reporting", "Real-time Analytics", "ML Integration"],
    icon: "BarChart3"
  }
];

export const featuresData = [
  {
    id: 1,
    title: "AI-Powered Intelligence",
    description: "Leverage machine learning algorithms to make smart automation decisions",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Real-time Monitoring",
    description: "24/7 monitoring and alerts to ensure your automation runs smoothly",
    icon: "Monitor"
  },
  {
    id: 3,
    title: "Seamless Integration",
    description: "Connect with 500+ tools and platforms without breaking existing workflows",
    icon: "Zap"
  },
  {
    id: 4,
    title: "Enterprise Security",
    description: "Bank-grade security with encryption, compliance, and audit trails",
    icon: "Shield"
  },
  {
    id: 5,
    title: "Custom Solutions",
    description: "Tailored automation solutions designed specifically for your business needs",
    icon: "Settings"
  },
  {
    id: 6,
    title: "24/7 Support",
    description: "Expert support team available around the clock to assist you",
    icon: "HeadphonesIcon"
  }
];

export const caseStudiesData = [
  {
    id: 1,
    company: "TechCorp Solutions",
    industry: "Software Development",
    challenge: "Manual deployment processes taking 4+ hours per release",
    solution: "Automated CI/CD pipeline with testing and deployment automation",
    results: "Reduced deployment time to 15 minutes, 99.9% uptime achieved",
    savings: "$2.4M annually",
    image: "/api/placeholder/400/300"
  },
  {
    id: 2,
    company: "FinanceFlow Inc",
    industry: "Financial Services",
    challenge: "Manual invoice processing and approval workflows",
    solution: "Intelligent document processing with automated approval chains",
    results: "90% faster invoice processing, eliminated manual errors",
    savings: "$1.8M annually",
    image: "/api/placeholder/400/300"
  },
  {
    id: 3,
    company: "RetailMax",
    industry: "E-commerce",
    challenge: "Inventory management and order fulfillment bottlenecks",
    solution: "Automated inventory tracking with predictive restocking",
    results: "40% reduction in stockouts, 60% faster order processing",
    savings: "$3.2M annually",
    image: "/api/placeholder/400/300"
  }
];

export const teamData = [
  {
    id: 1,
    name: "Sarah Chen",
    role: "CEO & Founder",
    bio: "15+ years in automation and AI, former Principal Engineer at Google",
    image: "/api/placeholder/300/300",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    role: "CTO",
    bio: "DevOps expert with 12+ years scaling infrastructure for Fortune 500",
    image: "/api/placeholder/300/300",
    linkedin: "https://linkedin.com",
    github: "https://github.com"
  },
  {
    id: 3,
    name: "Emily Watson",
    role: "Head of Product",
    bio: "Product strategist focused on user-centric automation solutions",
    image: "/api/placeholder/300/300",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  },
  {
    id: 4,
    name: "David Kim",
    role: "Lead Solutions Architect",
    bio: "Enterprise automation specialist with expertise in complex integrations",
    image: "/api/placeholder/300/300",
    linkedin: "https://linkedin.com",
    github: "https://github.com"
  }
];

export const pricingData = [
  {
    id: 1,
    name: "Starter",
    price: "$299",
    period: "per month",
    description: "Perfect for small teams getting started with automation",
    features: [
      "Up to 10 automated workflows",
      "Basic integrations (50+ tools)",
      "Email support",
      "Dashboard analytics",
      "1 GB data processing"
    ],
    popular: false,
    cta: "Start Free Trial"
  },
  {
    id: 2,
    name: "Professional",
    price: "$899",
    period: "per month",
    description: "Ideal for growing businesses with complex automation needs",
    features: [
      "Unlimited automated workflows",
      "Advanced integrations (500+ tools)",
      "Priority support",
      "Advanced analytics & reporting",
      "10 GB data processing",
      "Custom workflow templates",
      "API access"
    ],
    popular: true,
    cta: "Start Free Trial"
  },
  {
    id: 3,
    name: "Enterprise",
    price: "Custom",
    period: "pricing",
    description: "Tailored solutions for large organizations",
    features: [
      "Everything in Professional",
      "Dedicated account manager",
      "24/7 phone support",
      "Custom integrations",
      "Unlimited data processing",
      "On-premise deployment options",
      "SLA guarantees",
      "Training & onboarding"
    ],
    popular: false,
    cta: "Contact Sales"
  }
];

export const aboutData = {
  mission: "To empower businesses worldwide by eliminating manual work through intelligent automation, enabling teams to focus on innovation and growth.",
  vision: "A world where every business process is optimized, every team is empowered, and every organization can scale without limits.",
  values: [
    {
      title: "Innovation First",
      description: "We constantly push the boundaries of what's possible with automation technology"
    },
    {
      title: "Customer Success",
      description: "Your success is our success. We're committed to delivering measurable results"
    },
    {
      title: "Reliability",
      description: "Our solutions are built to work flawlessly, 24/7, so you can depend on them"
    },
    {
      title: "Transparency",
      description: "Clear communication, honest pricing, and open about our processes"
    }
  ],
  stats: [
    { number: "2019", label: "Founded" },
    { number: "250+", label: "Team Members" },
    { number: "50+", label: "Countries Served" },
    { number: "99.9%", label: "Uptime SLA" }
  ]
};

export const contactData = {
  email: "hello@zanyautomation.com",
  phone: "+1 (555) 123-4567",
  address: "123 Innovation Drive, Tech Valley, CA 94025",
  hours: "Monday - Friday, 9:00 AM - 6:00 PM PST"
};